import React from "react";
import { motion } from "framer-motion";

const HowCanWeHelpSlide = () => {
  return (
    <div className="h-full w-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center relative overflow-hidden font-sans">
      {/* Subtle grid with radial mask */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff15_1px,transparent_1px),linear-gradient(to_bottom,#ffffff15_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />

      {/* Floating particles */}
      {[...Array(8)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-1.5 h-1.5 bg-blue-200 rounded-full blur-[1px]"
          initial={{ opacity: 0 }}
          animate={{
            y: [null, Math.random() * -100],
            opacity: [0, 0.6, 0],
          }}
          transition={{
            duration: Math.random() * 4 + 3,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
          }}
        />
      ))}

      {/* Ambient blue/indigo blobs */}
      <motion.div
        animate={{
          y: [0, -30, 0],
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.5, 0.3],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-400 rounded-full blur-[120px] opacity-30 mix-blend-overlay"
      />
      <motion.div
        animate={{
          y: [0, 40, 0],
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        className="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] bg-indigo-400 rounded-full blur-[140px] opacity-30 mix-blend-overlay"
      />

      {/* Glow behind text */}
      <div className="absolute w-[900px] h-[400px] bg-blue-300/20 rounded-full blur-[100px]" />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 text-center px-8"
      >
        <motion.div
          initial={{ opacity: 0, letterSpacing: "0.4em" }}
          animate={{ opacity: 1, letterSpacing: "0.25em" }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-[11px] lg:text-xs font-bold uppercase text-blue-100/90 mb-8"
        >
          Asha AI OS
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="text-[56px] md:text-[80px] lg:text-[120px] font-extrabold tracking-tight leading-[1.05] text-white drop-shadow-sm"
        >
          So how can we{" "}
          <span className="relative inline-block">
            <span className="bg-gradient-to-br from-blue-100 via-blue-200 to-white bg-clip-text text-transparent italic">
              help
            </span>
            <span className="absolute -inset-2 bg-white/10 blur-2xl -z-10" />
          </span>
          ?
        </motion.h1>

        <motion.div
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="mt-10 mx-auto w-32 h-[1px] bg-gradient-to-r from-transparent via-white/60 to-transparent origin-center"
        />
      </motion.div>
    </div>
  );
};

export default HowCanWeHelpSlide;
